import { Component, Inject, OnInit, PLATFORM_ID, ViewEncapsulation } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { isPlatformServer } from '@angular/common';
import { NewsEmailSubscriptionComponent } from '../../news-email-subscription/news-email-subscription.component';

@Component({
  selector: 'app-footer-primary',
  templateUrl: './footer-primary.component.html',
  styleUrl: './footer-primary.component.scss',
  encapsulation: ViewEncapsulation.None
})
export class FooterPrimaryComponent implements OnInit {
  qualityQuestionFormVisibility = false;
  private intervalId: any;
  private storageKey = 'subscribe_showed_count';

  constructor(public dialog: MatDialog, @Inject(PLATFORM_ID) private platformId: any) {
  }

  ngOnInit() {
    if (isPlatformServer(this.platformId)) {
      return;
    }

    const showedCount = localStorage.getItem(this.storageKey);
    if (!(Number(showedCount) > 0)) {
      if (!this.intervalId) {
        this.intervalId = setTimeout(() => {
          this.dialog.open(NewsEmailSubscriptionComponent);
          localStorage.setItem(this.storageKey, '1');
        }, 30000);
      }
    }
  }

  getCurrentYear(): string {
    return (new Date()).getFullYear().toString();
  }

  qualityQuestionFormToggle(): void {
    this.qualityQuestionFormVisibility = !this.qualityQuestionFormVisibility;
  }

  // Метод для получения события от дочернего компонента
  onShowCallbackFormChange(newVisibility: boolean) {
    this.qualityQuestionFormVisibility = newVisibility;
  }
}
